 
import React from "react";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const StyledGauge = styled("div")(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  width: 100,
  height: 50,
  "& .semi-circle": {
    position: "relative",
    display: "block",
    width: 100,
    height: 50,
    background: theme.palette.blue300.main,
    borderRadius: "50% 50% 50% 50% / 100% 100% 0% 0%",
    "&:before": {
      content: "''",
      position: "absolute",
      bottom: 0,
      left: "50%",
      zIndex: 2,
      display: "block",
      width: 80,
      height: 40,
      transform: "translateX(-50%)",
      background: theme.palette.white.main,
      borderRadius: "50% 50% 50% 50% / 100% 100% 0% 0%",
    },
    "& .semi-circle-mask": {
      position: "absolute",
      top: 0,
      left: 0,
      width: 100,
      height: 100,
      background: "transparent",
      transform: "rotate(90deg) translate3d(0,0,0)",
      transformOrigin: "center center",
      backfaceVisibility: "hidden",
      transition: "all .3s ease-in-out",
      "&:before": {
        content: "''",
        position: "absolute",
        top: 0,
        left: "0",
        zIndex: 2,
        display: "block",
        width: 99,
        height: 50,
        margin: 0,
        background: theme.palette.grey200.main,
        borderRadius: "50% 50% 50% 50% / 100% 100% 0% 0%",
      },
    },
  },
}));

const SFGauge = ({ percentage }) => {
  return (
    <StyledGauge>
      <div className="semi-circle">
        <div className="semi-circle-mask"></div>
      </div>
    </StyledGauge>
  );
};

SFGauge.propTypes = {
  percentage: PropTypes.number,
};

export default SFGauge;
